var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-agent-content base-agent-term"},_vm._l((_vm.contents),function(li,idx){return _c('card-content',{key:'li-'+idx,attrs:{"list-text":li.listText,"text":li.text,"num":(idx+1) + ''},on:{"openModal":function($event){return _vm.$emit('openModal')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }